import { Formik, useFormik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  createAnnouncement,
  createCdlTypes,
  createInterest,
  createPublicRoom,
  createTitle,
  createTopics,
  createTruckType,
  getStatics,
} from "../../../store/actions/AdminAction";
import { toast } from "react-toastify";
const DropdownTypesModal = ({ viewVal, setViewVal, title, name }) => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState("");
  var initFormik = {
    [name]: "",
  }
  if(name == 'roomcategory'){
    initFormik.image= ""
  }

  return (
    <Modal
      show={viewVal}
      onHide={() => {
        setViewVal(false);
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="delete_account_modal"
    >
      <Modal.Body>
        <h4 className="text-center mb-0 delete_content">Create {title}</h4>

        <div className="card-body">
          <div className="basic-form">
            <Formik
              initialValues={initFormik}
              validate={(values) => {
                const errors = {};
                if (!values[name]) {
                  errors.cdltype = "Required*";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {

                if (name == "cdltype") {
                  dispatch(createCdlTypes(values));
                } else if (name == "trucktype") {
                  dispatch(createTruckType(values));
                } else if (name == "title") {
                  dispatch(createTitle(values));
                } else if (name == "interest") {
                  dispatch(createInterest(values));
                } else if (name == "roomcategory") {
                  const formData = new FormData();

                  for (const key in values) {
                      formData.append(key, values[key]);
                  }
                  dispatch(createTopics(formData));
                }

                setViewVal(false);
                setSubmitting(false);
              }}
            >
              {({
                setFieldValue,
                values,
                errors,
                handleChange,
                handleSubmit,
                isSubmitting,
                handleReset,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group mb-3 col-md-12">
                      <label>Title</label>
                      <input
                        type="text"
                        name={name}
                        className="form-control"
                        placeholder="Type Here..."
                        onChange={handleChange}
                        value={values[name]}
                      />
                      {errors[name] && (
                        <span class="formik-errors">{errors[name]}</span>
                      )}
                    </div>
                    {
                      name == 'roomcategory' && <div className="form-group mb-3 col-md-12">
                      <input
                        name="image"
                        onChange={(e) => {
                          setFieldValue(
                            `image`,
                            e.target.files[0]
                          );
                          setPreview(URL.createObjectURL(e.target.files[0]));
                        }}
                        type="file"
                        accept="image/*"
                        className="blog-upload-input"
                        placeholder="Upload Image"
                      />

                      <div className="blog-upload-img form-control-new">
                        {preview && <img src={preview} />}
                      </div>
                    </div>
                    }
                    
                  </div>

                  <div className="d-flex justify-content-center delete_acc_btns">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-primary btn-custom btn-lg  submit_btn confirmation_btn"
                    >
                      Create
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setViewVal(false);
                      }}
                      className="btn btn-primary btn-custom btn-lg submit_btn confirmation_btn"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DropdownTypesModal;
